// Missing/new routes return to their default group; stored layout cannot grant access.
export function orderedMenu(defaults, stored = []) {
  const routes = new Map(defaults.flatMap(g => g.items.map(item => [item.to.slice(1), item])));
  const seen = new Set();
  const groups = defaults.map(g => ({ section: g.section, items: [] }));
  for (const saved of stored) {
    const group = groups.find(g => g.section === saved.section);
    if (!group) continue;
    for (const key of saved.items || []) {
      if (routes.has(key) && !seen.has(key)) { group.items.push(routes.get(key)); seen.add(key); }
    }
  }
  defaults.forEach((g, index) => g.items.forEach(item => {
    if (!seen.has(item.to.slice(1))) groups[index].items.push(item);
  }));
  return groups;
}

export const serializeMenu = groups => groups.map(g => ({ section: g.section, items: g.items.map(i => i.to.slice(1)) }));

export function moveMenuItem(groups, route, section, targetRoute = null, after = false) {
  const item = groups.flatMap(g => g.items).find(i => i.to === route);
  if (!item || route === targetRoute || !groups.some(g => g.section === section)) return groups;
  return groups.map(g => {
    const items = g.items.filter(i => i.to !== route);
    if (g.section === section) {
      const index = targetRoute ? items.findIndex(i => i.to === targetRoute) : 0;
      items.splice(index < 0 ? items.length : index + (after ? 1 : 0), 0, item);
    }
    return { ...g, items };
  });
}